export class ListTagDefinitionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "definitions",
            "baseName": "definitions",
            "type": "Array<DataCatalogTagDefinition>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListTagDefinitionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
